import { render, staticRenderFns } from "./JacRegionList.vue?vue&type=template&id=29ead686&scoped=true"
import script from "./JacRegionList.vue?vue&type=script&lang=js"
export * from "./JacRegionList.vue?vue&type=script&lang=js"
import style0 from "./JacRegionList.vue?vue&type=style&index=0&id=29ead686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ead686",
  null
  
)

export default component.exports